import remoteApi from "common/remote/api";
import { RequestResultItem } from "./requests.model";

export const onRequestFetch = (): Promise<RequestResultItem[]> =>
	remoteApi.get("/routineSlot/get/requested_RoutineSlots/");

export const onRequestApprove = (slotId: number): Promise<RequestResultItem> =>
	remoteApi.post(`/routineSlot/accept_requested_class/${slotId}`);
